module.exports = __webpack_public_path__ + "9b29405feaee35b2f800fe9e6c9a0812.svg";